(() => {
  if (customElements.get('accordion-item')) {
    return;
  }

  class AccordionItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelector('summary').addEventListener(
        'click',
        this.toggle.bind(this),
      );
    }

    toggle(event) {
      event.preventDefault();
      const this_details = this.querySelector('details');
      const isActive = this_details.hasAttribute("is-open");
      for (const child of this.parentElement.children) {
        child.querySelector('details').removeAttribute('is-open');
      }
      if (!isActive) this_details.setAttribute("is-open", "");
      //this.querySelector('details').toggleAttribute('is-open');
    }
  }

  customElements.define('accordion-item', AccordionItem);
})();
